import React, { useEffect, useState } from 'react'
import Layout from './layout'
import Subpages from './public/subpages'
import useMediaQuery from '../hooks/useMediaQuery'
import { Link, useParams } from 'react-router-dom'
import { BASE_URL, getNewList, qyfcList } from '../api/api'
import Pagination from './pagination'
import NavLink from './navLink'
import Ltyw from './home/ltyw'

const Qyfc = () => {
  const isMobile = useMediaQuery()
  const { channel_id = 1, page = 1 } = useParams()
  const pagesize = 50

  const [data, setData] = useState([])
  const [qyfc, setQyfc] = useState({})

  useEffect(() => {
    getNewList(
      `archives/newsList?pagesize=${pagesize}&channel_id=${channel_id}&page=${page}`.replace(
        '.html',
        ''
      )
    ).then(res => {
      setData(res?.data)
    })
    qyfcList().then(res => {
      setQyfc(res.data)
    })
  }, [pagesize, channel_id, page])

  return (
    <Layout>
      <Subpages className="px-5 lg:px-0 mb-10 lg:mb-0" name="企业风采">
        {/* <Ltyw
          isTitleShow={false}
          imgNews={qyfc?.imgNews || []}
          impNewsList={qyfc?.impNewsList || []}
        /> */}
        <div className="flex flex-row justify-between flex-wrap mt-12">
          {data?.list?.data?.map(({ id, image = '', title, outlink = '' }) => (
            <NavLink
              isOutLink={!!outlink}
              className="w-[46%] lg:w-[213px]"
              to={outlink || `/wzxq/id/${id}`}
              key={id}
            >
              <img
                className="mt-[30px]"
                src={`${BASE_URL}${image}`}
                style={{ width: isMobile ? '100%' : 213, height: 126 }}
                alt=""
              />
              <p className="text-center mt-4 font-sourceHan text-[#333333]">{title}</p>
            </NavLink>
          ))}
          <div className="w-[213px]"></div>
          <div className="w-[213px]"></div>
          <div className="w-[213px]"></div>
        </div>
        <Pagination
          count={data?.list?.total}
          pagesize={pagesize}
          page={data?.list?.current_page}
          totalPage={data?.list?.last_page}
        />
      </Subpages>
    </Layout>
  )
}

export default Qyfc
